import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import UpdatePage from '../../../composents/UpdatePage'
import { useParams } from 'react-router-dom'

const title = 'Pay Back'
const headers = {
  icon: 'feather icon-plus',
  title,
  description: 'pay back',
  breadcrumbs: [
    {
      title,
      link: '/clients/top_up',
    },
  ],
}

const cardOptions = [
  {
    value: 'cash',
    label: 'Cash',
  },
  {
    value: 'card',
    label: 'Card',
  },
]

export default function PayBackConsumerConfirm() {
  const [loader, setLoader] = useState(false),
    { id } = useParams(),
    [errors, setErrors] = useState({}),
    [data, setData] = useState({}),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true)

  async function onGet() {
    setLoading(true)
    const response = await resources.payBack
      .readOne(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (response.status === 200) {
      setData(response.data)
    } else if (response.status === 403) {
      setFail(true)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = Object.fromEntries(formData)
    object.status = 2
    object.payBackData = {
      card: object.card,
      id: object.id,
    }

    setLoader(true)
    setErrors({})
    let res = await resources.payBack
      .update(id, object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/clients/paybacks')
    } else if (res.status === 422) {
      const errors = res.data.errors.reduce((acc, error) => {
        return { ...acc, [error.field]: error.message }
      }, {})
      setErrors(errors)
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
      message="this page require clients,cards,subscriptions and consumers authorization"
    >
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <Field className="mb-3" value={data?.consumer?.surname || ''} readOnly>
                  Consumer
                </Field>

                <Field className="mb-3" value={data?.consumer?.wallet || 0} readOnly type="number">
                  Wallet balance
                </Field>

                <Field
                  className="mb-3"
                  type="number"
                  error={errors['payBack']}
                  required
                  readOnly
                  value={data?.payBack}
                >
                  Pay Back
                </Field>

                <Field className="mb-3" readOnly value={data?.payment}>
                  Pay Back
                </Field>

                {data?.payment === 'card' && (
                  <Field
                    className="mb-3"
                    name="card"
                    required
                    defaultValue={data?.payBackData?.card}
                  >
                    Card
                  </Field>
                )}

                <Field className="mb-3" required={data?.payment === 'card'} name="id">
                  Transaction id
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
